import featureFlagsDictionary from "./feature-flags-dictionary";

const sdkConfig: SplitIO.IBrowserSettings = {
  core: {
    authorizationKey: process.env.REACT_APP_SPLIT_APIKEY as string,
    key: "key",
  },
  features: {
    [featureFlagsDictionary.BI_6]: "on",
    [featureFlagsDictionary.BI_264]: "on",
    [featureFlagsDictionary.BT_10]: "off",
    [featureFlagsDictionary.BT_997]: "on",
    [featureFlagsDictionary.COB_1796]: "on",
    [featureFlagsDictionary.ET_337]: "on",
    [featureFlagsDictionary.EG_398]: "on",
    [featureFlagsDictionary.BI_1434]: "on",
    [featureFlagsDictionary.BI_2174]: "on",
    [featureFlagsDictionary.BI_2458]: "on",
    [featureFlagsDictionary.BI_2406]: "on",
    [featureFlagsDictionary.ENT_259]: "on",
    [featureFlagsDictionary.SMES_2112]: "on",
    [featureFlagsDictionary.BI_3777]: "on",
    [featureFlagsDictionary.SMES_2223]: "off",
    [featureFlagsDictionary.BA_134]: "on",
    [featureFlagsDictionary.BI_7735]: "on",
  },
};

export default sdkConfig;
